export * from './OffersCardCarouselSkeletonLoader';
export { default } from './OffersCardCarouselSkeletonLoader';
